import { z } from 'zod'
import { PageSource } from '@mc/track-event'
import { createTracking } from '@mc/tracking-kit'

const giftSchema = {
  moduleViewed: {
    eventName: 'Module Viewed',
    schema: z.object({
      page_source: z.literal(PageSource.GIFT),
      category: z.literal('Gifts Landing Page'),
      row: z.enum(['Gift Showcase', 'Gift Cards for Business']),
    }),
  },
}

const pageSchema = z.object({
  name: z.enum([PageSource.GIFT]),
})

export const { TrackVisible, TrackingAttributes } = createTracking(
  giftSchema,
  pageSchema,
)
